import dynamic from "next/dynamic";

const SlideView = dynamic(() => import("./SlideView"), {
  ssr: false
});

export default SlideView;